import React, { Component, useState } from 'react';
import { Form, Field } from 'react-final-form';
import { Button, CustomInput, Alert, CardTitle, Badge, Card, CardBody } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import Logic from './../../Logic';
import ValidatedField from '../ValidatedField/ValidatedField';
import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';
import JsonViewer from '../JsonViewer/JsonViewer';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const CreateUserForm = (props) => {

  const labels = {
    required: 'שדה חובה',
    invalidIdentityNumber: 'מספר ת\"ז אינו תקין',
    invalidEmail: 'דואר אלקטרוני אינו תקין',
    invalidMobile: 'מספר טלפון נייד צריך להיות בן 10 ספרות בלבד',
    identityNumberLength: 'אורך מספר הזהות חייב להיות 9 ספרות'
  }

  function validate(values){ // candidate creation by user
    const logic = new Logic();
    const errors = {};

    if(!values.identityNumber || values.identityNumber && values.identityNumber.trim() == ''){
      errors.identityNumber = labels.required;
    }

    if(!values.isMeetInPerson){
      errors.isMeetInPerson = labels.required;
    }

    if(values.identityNumber && !logic.validateIdentityNumber(values.identityNumber)){
      errors.identityNumber = labels.invalidIdentityNumber;
    }

    if(values.identityNumber && values.identityNumber.length != 9){
      errors.identityNumber = labels.identityNumberLength;
    }

    if(!values.firstName || values.firstName && values.firstName.trim() == ''){
      errors.firstName = labels.required;
    }

    if(!values.position || values.position && values.position.trim() == ''){
      errors.position = labels.required;
    }

    if(!values.lastName || values.lastName && values.lastName.trim() == ''){
      errors.lastName = labels.required;
    }

    if(!values.privateEmail || values.privateEmail && values.privateEmail.trim().length == 0){
      errors.privateEmail = labels.required;
    }

    if(values.privateEmail && (values.privateEmail.length < 8 || values.privateEmail.indexOf('@') == -1)){
      errors.privateEmail = labels.invalidEmail
    }

    if(!values.mobilePhone || values.mobilePhone && values.mobilePhone.trim().length == 0){
      errors.mobilePhone = labels.required;
    }

    if(values.mobilePhone && values.mobilePhone.match(/^0\d{9}$/) == null){
      errors.mobilePhone = labels.invalidMobile
    }

    // logic.log(errors);
    return errors;
  }

  const onSubmit = async (values) => {
      let vendor = props.init.user.vendors.filter(a => a.Key === values.vendor)[0];
      let res = await props.onFormSubmitted({...values, vendor: {Key:vendor.Key, Value: vendor.Value}}); //fix the data in order to match the vm format
      return res;
  }

  function getInitialValue(){
    return {
      id: -1, 
      mobilePhone:null, 
      privateEmail:null, 
      vendor: props.init.user.vendors[0].Key,
      employmentEnvironmentId: 1,
      position:null, 
      lastName:null, 
      firstName:null, 
      identityNumber:null, 
      isFillFormsByAdmin: null
    };
  }


  return (
  <div>
    <h1 className="card-title col-sm-10">{props.formTitle}</h1>
    <Form
    onSubmit={onSubmit}
    validate={values => validate(values)}
    initialValues={getInitialValue()} 
    render={({ handleSubmit, form, submitting, pristine, values }) => (
    <form onSubmit={handleSubmit} style={{padding:'1rem'}}>

      <h5>פרטים אישיים</h5>
      <div className="form-inline">
        <div className="form-group col-md-4 col-sm-12">
          <ValidatedField label="תעודת זהות" name="identityNumber" type="text" placeholder="תעודת זהות" cols="12"/>
        </div>

        <div className="form-group col-md-4 col-sm-12">
          <ValidatedField label="שם פרטי" name="firstName" type="text" placeholder="שם פרטי" cols="12"/>
        </div>

        <div className="form-group col-md-4 col-sm-12">
          <ValidatedField label="שם משפחה" name="lastName" type="text" placeholder="שם משפחה" cols="12"/>
        </div>
      </div>

      <br/>
      <h5>פרטי העסקה</h5>
      <div className="form-inline">
        <div className="form-group col-md-4 col-sm-12">
          <label>ספק</label>
            <Field id="vendor" name="vendor" className="form-control col-md-12" component="select" value={props.init.candidate ? props.init.candidate.vendor.Key : props.init.user.vendors[0].Key}> {/* value={props.init.candidate ? props.init.candidate.vendor.Key : values.vendor ? values.vendor.Key : props.init.user.vendors[0].Key} */}
            {props.init.user.vendors.map(p => <option key={p.Key} value={p.Key}>{p.Value}</option>)}
            </Field>
        </div>

        <div className="form-group col-md-4 col-sm-12">
          <label>סביבת העסקה</label>
          <Field name="employmentEnvironmentId" className="form-control col-md-12" component="select" value={props.init.candidate ? props.init.candidate.employmentEnvironmentId : props.init.employmentEnvironments[0].Key}>
          {props.init.employmentEnvironments.map(p=><option value={p.Key} key={p.Key}>{p.Value}</option>)}
          </Field>
        </div>

        <div className="form-group col-md-4 col-sm-12">
          <ValidatedField label="תפקיד" name="position" type="text" placeholder="תפקיד" cols="12"/>
        </div>
      </div>

      <br/>
      <h5>פרטי התקשרות</h5>
      <div className="form-inline">
        <div className="form-group col-md-6 col-sm-12"> 
          <ValidatedField label="דואר אלקטרוני" name="privateEmail" type="text" placeholder="israel.israeli@gmail.com" cols="12"/>
        </div>
        <div className="form-group col-md-6 col-sm-12">
          <ValidatedField label="מספר סלולרי" name="mobilePhone" type="text" placeholder="מספר סלולרי" cols="12"/>
        </div>
      </div>
    
      <div className="col-sm-12">
        <br/><br/>
        <ValidatedCheckbox name="isMeetInPerson" type="checkbox" label="אני מצהיר/ה בזאת כי פגשתי פיזית את ממלא השאלון ובדקתי את זהותו והיא נמצאה כנכונה על פי תעודת זהות (מקור)." validated={true}/>
      </div>

      <button className="btn btn-link" style={{marginTop:'2rem', marginRight:'1rem'}} onClick={form.reset} disabled={submitting || pristine}><FontAwesome name="times"/> נקה</button>

      <div className="form-inline" style={{marginTop:'2rem', alignItems:'center', justifyContent:'center', margin:'auto'}}>
        <div className="d-none d-md-block col-md-3"></div>
        
        <div className="form-group col-md-3 col-sm-6" style={{textAlign:'left'}}>
          <Field name="isFillFormsByAdmin" component="input" type="hidden"/>
          <Button color="secondary" onClick={() => { values.isFillFormsByAdmin = false; handleSubmit(values); }}>למילוי על ידי מועמד</Button>
        </div>

        <div className="form-group col-md-3 col-sm-6">
          <Button color="primary" onClick={() => { values.isFillFormsByAdmin = true; handleSubmit(values);}}>למילוי על ידי נאמן ביטחון</Button>
        </div>

        <div className="d-none d-md-block col-md-3"></div>
      </div>

      <JsonViewer init={props.init} data={values}/>

      </form>
    )}/>
  </div>);
};

export default CreateUserForm;